/** Feedback object - "When did it happen?" */
export var FeedbackObjectType;
(function (FeedbackObjectType) {
    FeedbackObjectType["ITINERARY"] = "itinerary";
    FeedbackObjectType["PROCEDURE"] = "procedure";
    FeedbackObjectType["WAYPOINT"] = "waypoint";
    FeedbackObjectType["WAYPOINT_ACTION"] = "waypointAction";
})(FeedbackObjectType || (FeedbackObjectType = {}));
/** Feedback subject - "What was involved?" */
export var FeedbackSubjectType;
(function (FeedbackSubjectType) {
    FeedbackSubjectType["PLACE"] = "place";
    FeedbackSubjectType["SUPPLY"] = "supply";
    FeedbackSubjectType["USER"] = "user";
    FeedbackSubjectType["CARESEND"] = "careSend";
})(FeedbackSubjectType || (FeedbackSubjectType = {}));
/** Feedback channel - "How was the feedback provided?" */
export var FeedbackChannel;
(function (FeedbackChannel) {
    FeedbackChannel["EMAIL"] = "email";
    FeedbackChannel["PHONE"] = "phone";
    FeedbackChannel["SMS"] = "sms";
    /** Feedback giving through our CareSend pro app using the feedback modal. */
    FeedbackChannel["CARESEND_PRO"] = "careSendPro";
})(FeedbackChannel || (FeedbackChannel = {}));
/** Category assigned to the provided feedback */
export var FeedbackCategory;
(function (FeedbackCategory) {
    FeedbackCategory["ACCESS_INSTRUCTIONS"] = "accessInstructions";
    FeedbackCategory["COMMUNICATION"] = "communication";
    FeedbackCategory["EXPERIENCE"] = "experience";
    FeedbackCategory["MEDICAL_SERVICE"] = "medicalService";
    FeedbackCategory["ONBOARDING"] = "onboarding";
    FeedbackCategory["SUPPLIES_MALFUNCTION"] = "suppliesMalfunction";
    FeedbackCategory["SUPPLIES_MISSING"] = "suppliesMissing";
    FeedbackCategory["TECH"] = "tech";
})(FeedbackCategory || (FeedbackCategory = {}));
//# sourceMappingURL=feedback.js.map